// extracted by mini-css-extract-plugin
module.exports = {"BookEasyPen":"_2Gj1M2Q-6tQnj6uMSSWktF"};